var ModuleService = function() {
  this.completePages = function(model) {
    var lastPage = model.activities.last().pages.last();
    model.setLastCompletedPage(lastPage);
    model.applyModuleStatus();
    model.set('completed', true);
  };

  this.markComplete = function(model) {
    model.progress.markComplete();
  };
};

module.exports = new ModuleService();